module.exports = new __parcel__URL__("inbox-view-table-skeleton.tpl.3e3d3620.svg").toString();